import { render, staticRenderFns } from "./CUPravna.vue?vue&type=template&id=c24e20da&"
import script from "./CUPravna.vue?vue&type=script&lang=js&"
export * from "./CUPravna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports